import React, { useEffect, useMemo, useState } from 'react';
import { validate } from '@/utils/validations';
import { FormContainer, FormItem, FormRow } from '../styled';
import { useAppContext } from '@/context';
import { Input } from '@/components/Input';
import { cityNoContent, useErrorFieldHandler, useSetFormValue } from '@/utils';
import { useCitiesFilter } from '@/components/FormWrapper/hooks';
import { Select } from '@/components/Select';
import schema from './validation';
import { DynamicObject, Errors } from './types';
import { useFreight, useTracker } from '@/hooks';

export const Travel: React.FC = () => {
  const { dispatch, state } = useAppContext();
  const [errorsState, setErrors] = useState<Errors>();
  const citiesFilter = useCitiesFilter();
  const tracker = useTracker();
  const form = useMemo(() => ({ ...state.risk.data }), [state.risk.data]);
  const { freightId } = useFreight();
  const triedToSubmit = useMemo(() => state.risk.triedToSubmit, [state.risk.triedToSubmit]);
  const setFormValue = useSetFormValue(dispatch);
  const errorFieldHandler = useErrorFieldHandler(dispatch);

  useEffect(() => {
    const errors = validate<Errors>(schema, form);
    if (triedToSubmit) setErrors(errors);
  }, [triedToSubmit, form]);

  useEffect(() => {
    errorFieldHandler(errorsState as unknown as DynamicObject);
  }, [errorsState]);

  useEffect(() => {
    tracker.dispatchWithUserData('risk_management_form_freight_viewed');
  }, []);

  useEffect(() => {
    if (triedToSubmit) {
      dispatch({ action: 'risk_set_is_valid', payload: !Boolean(errorsState) });
    }
  }, [errorsState]);

  useEffect(() => {
    if (freightId) setFormValue('travel.freightId', freightId);
  }, []);

  return (
    <FormContainer>
      <FormRow>
        <FormItem>
          <Input
            required
            label="Tipo da mercadoria"
            onUpdate={(value) => setFormValue('travel.cargoType', value)}
            value={form.travel.cargoType}
            error={errorsState?.travel?.cargoType}
            name="cargoType"
          />
        </FormItem>
        <FormItem>
          <Input
            required
            label="Valor da carga"
            monetary
            unmaskedValue
            onUpdate={(value) => setFormValue('travel.cargoValue', value)}
            value={form.travel.cargoValue}
            error={errorsState?.travel?.cargoValue}
            name="cargoValue"
          />
        </FormItem>
      </FormRow>

      <FormRow>
        <FormItem sm={4} md={2} lg={2}>
          <Select
            label="Local de origem"
            onUpdate={(value) => setFormValue('travel.originPlace', value)}
            optionLabel="place"
            optionValue="place"
            options={[]}
            filter={citiesFilter}
            placeholder="Digite para buscar a cidade"
            scrollable
            noContent={cityNoContent}
            noArrow
            filterOnFocus
            inputAutoFocus
            lazy
            debounceFilter={350}
            value={form.travel.originPlace}
            error={errorsState?.travel?.originPlace}
            name="originPlace"
          />
        </FormItem>

        <FormItem sm={4} md={2} lg={2}>
          <Select
            label="Local de destino"
            onUpdate={(value) => setFormValue('travel.destinationPlace', value)}
            optionLabel="place"
            optionValue="place"
            options={[]}
            filter={citiesFilter}
            placeholder="Digite para buscar a cidade"
            scrollable
            noContent={cityNoContent}
            noArrow
            filterOnFocus
            inputAutoFocus
            lazy
            debounceFilter={350}
            value={form.travel.destinationPlace}
            error={errorsState?.travel?.destinationPlace}
            name="destinationPlace"
          />
        </FormItem>
      </FormRow>
    </FormContainer>
  );
};
